module.exports = __webpack_public_path__ + "static/media/bbc_news_world-europe-35869254_plot.1bef1c72.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_news_world-europe-35869254_plot.png
// module id = 360
// module chunks = 0